var map = {
	"./404.svg": 50440,
	"./areaEdit.svg": 98085,
	"./btn.svg": 16012,
	"./bug.svg": 85036,
	"./chart.svg": 61849,
	"./clear.svg": 68213,
	"./clipboard.svg": 55716,
	"./close.svg": 70666,
	"./component.svg": 89409,
	"./copy-min-purchase-num.svg": 80433,
	"./copy.svg": 32677,
	"./copyDeclare.svg": 34820,
	"./copyNum.svg": 34581,
	"./copyPrice.svg": 56819,
	"./dashboard.svg": 96290,
	"./documentation.svg": 69216,
	"./download-1--hover.svg": 63303,
	"./download-1.svg": 33412,
	"./download-report--hover.svg": 86993,
	"./download-report.svg": 21113,
	"./drag.svg": 13760,
	"./edit.svg": 66380,
	"./education.svg": 58541,
	"./email.svg": 24711,
	"./example.svg": 74914,
	"./excel.svg": 79045,
	"./exit-fullscreen.svg": 33074,
	"./eye-open.svg": 40572,
	"./eye.svg": 94926,
	"./filter-item.svg": 68443,
	"./filter-itemnews-1.svg": 64511,
	"./filter-itemnews.svg": 65343,
	"./flag.svg": 23521,
	"./form.svg": 18004,
	"./fullscreen.svg": 75046,
	"./goods-da.svg": 40586,
	"./guide.svg": 51308,
	"./help--hover.svg": 59456,
	"./help.svg": 97468,
	"./hover-menu-analysis-white.svg": 80395,
	"./hover-menu-analysis.svg": 97338,
	"./hover-menu-finance-white.svg": 35216,
	"./hover-menu-finance.svg": 44696,
	"./hover-menu-goods-white.svg": 76755,
	"./hover-menu-goods.svg": 47415,
	"./hover-menu-manage-white.svg": 31142,
	"./hover-menu-manage.svg": 1819,
	"./hover-menu-order-white.svg": 965,
	"./hover-menu-order.svg": 91541,
	"./hover-menu-purchase-white.svg": 79523,
	"./hover-menu-purchase.svg": 82411,
	"./hover-menu-realtime-report-white.svg": 46549,
	"./hover-menu-realtime-report.svg": 61110,
	"./hover-menu-settings-white.svg": 66043,
	"./hover-menu-settings.svg": 93277,
	"./hover-menu-slogan-white.svg": 97221,
	"./hover-menu-slogan.svg": 61378,
	"./hover-menu-warehouse-white.svg": 66052,
	"./hover-menu-warehouse.svg": 91043,
	"./icon-arrow-down.svg": 8451,
	"./icon-arrow-up.svg": 92842,
	"./icon-download.svg": 78783,
	"./icon-fix-hover.svg": 38148,
	"./icon-fix.svg": 58862,
	"./icon-operation-col-more.svg": 8971,
	"./icon.svg": 27800,
	"./info.svg": 28224,
	"./inspec-in.svg": 70312,
	"./inspec-out.svg": 22090,
	"./international.svg": 46890,
	"./language.svg": 54348,
	"./link-1--hover.svg": 25765,
	"./link-1.svg": 39427,
	"./link-news.svg": 1557,
	"./link.svg": 79944,
	"./list.svg": 2724,
	"./lock.svg": 91986,
	"./logisticsAble.svg": 49400,
	"./logisticsDelete.svg": 45558,
	"./logisticsEdit.svg": 39320,
	"./logo.svg": 37669,
	"./menu-ad-white.svg": 10829,
	"./menu-analysis-white.svg": 26932,
	"./menu-analysis.svg": 75623,
	"./menu-bi-white.svg": 69008,
	"./menu-finance-white.svg": 87008,
	"./menu-finance.svg": 52161,
	"./menu-goods-white.svg": 57206,
	"./menu-goods.svg": 81773,
	"./menu-manage-white.svg": 71592,
	"./menu-manage.svg": 8938,
	"./menu-order-white.svg": 77589,
	"./menu-order.svg": 68381,
	"./menu-purchase-white.svg": 39238,
	"./menu-purchase.svg": 6056,
	"./menu-realtime-report-white.svg": 35045,
	"./menu-realtime-report.svg": 63390,
	"./menu-settings-white.svg": 44897,
	"./menu-settings.svg": 31795,
	"./menu-slogan-white.svg": 30372,
	"./menu-slogan.svg": 29188,
	"./menu-warehouse-white.svg": 22514,
	"./menu-warehouse.svg": 62744,
	"./message.svg": 98318,
	"./money.svg": 28599,
	"./msg.svg": 8425,
	"./nested.svg": 66016,
	"./order-process.svg": 23497,
	"./page.svg": 92097,
	"./password.svg": 97771,
	"./pay-manage.svg": 26404,
	"./pdf.svg": 99683,
	"./people.svg": 77048,
	"./peoples.svg": 52314,
	"./purchase-manage.svg": 29937,
	"./qq.svg": 87990,
	"./question-1--hover.svg": 54691,
	"./question-1.svg": 20800,
	"./question.svg": 74074,
	"./questionMark.svg": 8752,
	"./refresh-1--hover.svg": 69850,
	"./refresh-1.svg": 28762,
	"./reset-1.svg": 12896,
	"./reset-2.svg": 54787,
	"./ruleEdit.svg": 2139,
	"./search-news.svg": 68507,
	"./search.svg": 45138,
	"./select1.svg": 73438,
	"./select2.svg": 14587,
	"./setting-1--hover.svg": 92122,
	"./setting-1.svg": 35187,
	"./shop-auth.svg": 6565,
	"./shopping.svg": 13862,
	"./size.svg": 54829,
	"./skill.svg": 58427,
	"./spread.svg": 65666,
	"./star.svg": 10690,
	"./super-search.svg": 23641,
	"./tab.svg": 51028,
	"./table.svg": 78617,
	"./theme.svg": 26796,
	"./tree-table.svg": 12814,
	"./tree.svg": 75426,
	"./tuozhuai.svg": 78227,
	"./user.svg": 16707,
	"./warehouse-view.svg": 47200,
	"./wechat.svg": 98980,
	"./zip.svg": 56173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;